import script from "./RcDropdownItemCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcDropdownItemCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./RcDropdownItemCheckbox.vue?vue&type=style&index=0&id=22f64ef8&lang=scss&scoped=true"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f64ef8"]])

export default __exports__